module.exports = "<p>\n  drilling-table works!\n</p>\n"